import { BookkeepingDetailSection } from "bookkeeping/BookkeepingDetailSection";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React, { useState } from "react";
import BookkeepingOptionsPanel from "../BookkeepingOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import LinkedItems from "company/detail/linkedItems/App";
import { isPanelVisible } from "utilities/panelUtils";
import { BookkeepingActivityPanel } from "bookkeeping/activity/BookkeepingActivityPanel";
import { VatRatesPanel } from "bookkeeping/VatRatesPanel";
import { useLoaderData } from "react-router";

export const BookkeepingDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BookkeepingDetailFrontModel>();

  const [bookkeeping, setBookkeeping] = useState(viewModel.bookkeeping);
  const [einvoiceCompliance, setEinvoiceCompliance] = useState(viewModel.eInvoiceCompliance);
  const [emails, setEmails] = useState(viewModel.emails);

  const refreshBookkeeping = async () => {
    const updatedBookkeeping = await window.CoreApi.Bookkeeping.GetSidePanelData(viewModel.bookkeeping.bookkeepingId);
    setBookkeeping(updatedBookkeeping.data.data.bookkeeping);
    setEinvoiceCompliance(updatedBookkeeping.data.data.eInvoiceCompliance);
    setEmails(updatedBookkeeping.data.data.emails);
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <BookkeepingDetailSection
            bookkeeping={bookkeeping}
            emails={emails}
            onChange={setBookkeeping}
            isLastVisible={viewModel.bookkeepingIsLastVisible}
            isUsedInDocuments={viewModel.bookkeepingIsUsedInDocuments}
            einvoiceCompliance={einvoiceCompliance}
            refetchBookkeeping={refreshBookkeeping}

          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BookkeepingOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            bookkeepingId={viewModel.bookkeeping.bookkeepingId}
            isUsedInDocuments={viewModel.bookkeepingIsUsedInDocuments}
          />
          {isPanelVisible(viewModel.linkedItemCountPanelConfig) && <LinkedItems
            config={viewModel.linkedItemCountPanelConfig}
            linkedItems={viewModel.linkedCount}
          />}
          <VatRatesPanel country={bookkeeping.companyAdmCountry} />
          {isPanelVisible(viewModel.activityPanel) && <BookkeepingActivityPanel
            config={viewModel.activityPanel}
            bookkeepingId={viewModel.bookkeeping.bookkeepingId}
          />}
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}